<template>
  <div class="templates">
    <h2 class="hidden-text">Skabeloner</h2>
    <h3>Nyhedsbrevet</h3>
    <hr>
    <b-row class="mb-5">
      <b-col cols="12" md="6">
        <template-group endpoint="newsletter"></template-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-table
          small
          :items="items"
          :fields="fields"
        >
          <template v-slot:cell(macro)="row">
            <span class="text-secondary">{{ row.item.macro }}</span>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <h3>Tilmelding</h3>
    <hr>
    <b-row>
      <b-col cols="12" md="6">
        <h4 class="h5">Bekræftelse af mailadresse</h4>
        <template-group endpoint="confirmation-request" :caption="requestCaption"></template-group>
      </b-col>
      <b-col cols="12" md="6">
        <h4 class="h5">Tilmelding bekræftet</h4>
        <template-group endpoint="signup-confirmation"></template-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import TemplateGroup from './components/TemplateGroup.vue'
export default {
  components: {
    TemplateGroup
  },
  data: () => ({
    requestCaption: 'Indholdsteksten (HTML) i bekræftelsesmail. Makroen $verifyurl skal indgå i mailen, da den indeholder information overfor brugeren hvor emailaddresse kan bekræftes.',
    fields: [
      {
        key: 'macro',
        label: 'Macro'
      },
      {
        key: 'description',
        label: 'Beskrivelse'
      }
    ]
  }),
  computed: {
    items() {
      return this.$store.state.macros
    }
  }
}
</script>

<style>

</style>